import React, { useEffect, useRef, useState } from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';
import { useSelector } from 'react-redux';
import ConfettiCannon from 'react-native-confetti-cannon';

const CartCompleteConfetti = () => {
  const shouldCelebrate = useSelector(state => {
    const prompt = state.scanToCart?.currentCartScanComplete;
    return Boolean(prompt?.isVisible && prompt?.celebrate);
  });

  const [showConfetti, setShowConfetti] = useState(false);
  const wasCelebratingRef = useRef(false);

  useEffect(() => {
    if (shouldCelebrate && !wasCelebratingRef.current) {
      setShowConfetti(true);
    }
    wasCelebratingRef.current = shouldCelebrate;
  }, [shouldCelebrate]);

  if (!showConfetti) return null;

  const { width } = Dimensions.get('window');

  return (
    <View style={styles.overlay} pointerEvents="none">
      <ConfettiCannon
        count={150}
        origin={{ x: width / 2, y: -20 }}
        explosionSpeed={350}
        fallSpeed={2800}
        fadeOut={true}
        autoStart={true}
        onAnimationEnd={() => setShowConfetti(false)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 9999,
  },
});

export default CartCompleteConfetti;
